import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { anotherUserDetail, userDetail } from './api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('token')); // 保存 token
    const [user, setUser] = useState(null); // 用户信息
    const [anotherUser, setAnotherUser] = useState(null); // 另一个用户信息
    const [loading, setLoading] = useState(true); // 控制加载状态
    const [tokenExpired, setTokenExpired] = useState(false); // token 是否过期的状态

    const navigate = useNavigate();

    // 检查 token 是否过期
    const isTokenExpired = (token) => {
        if (!token) return true;
        try {
            const payload = JSON.parse(atob(token.split('.')[1])); // 解码 token 获取 payload
            return Date.now() >= payload.exp * 1000; // 如果当前时间大于 token 中的过期时间，返回 true
        } catch (e) {
            return true; // 如果解析失败，认为 token 无效
        }
    };

    // 更新 token，并且根据 token 是否有效获取用户信息
    const setTokenAndFetchUserInfo = (token) => {
        setToken(token);
        if (token && !isTokenExpired(token)) {
            localStorage.setItem('token', token);
            setTokenExpired(false); // token 是有效的
            fetchUserInfo(); // 获取用户信息
        } else {
            setTokenExpired(true); // token 无效或已过期
            localStorage.removeItem('token');
        }
    };

    // 获取用户信息
    const fetchUserInfo = async () => {
        try {
            const userInfo = await userDetail();
            const anotherUser = await anotherUserDetail();
            setUser(userInfo);
            setAnotherUser(anotherUser);
        } catch (error) {
            console.error('Failed to fetch user info:', error);
            setTokenExpired(true); // 如果获取用户信息失败，认为 token 失效
            localStorage.removeItem('token');
            setToken(null);
            navigate('/'); // 跳转到登录页面
        } finally {
            setLoading(false); // 设置为已加载
        }
    };

    // 处理 token 变化时的跳转逻辑
    useEffect(() => {
        if (token && !isTokenExpired(token)) {
            // token 有效，获取用户信息
            setTokenExpired(false); // 清除过期状态
            fetchUserInfo();
        } else {
            // token 无效或过期
            setTokenExpired(true);
            setToken(null);
            localStorage.removeItem('token');
            setLoading(false);
            navigate('/'); // 跳转到登录页面
        }
    }, [token, navigate]); // 当 token 更新时，执行这个 effect

    return (
        <AuthContext.Provider value={{
            token,
            setToken: setTokenAndFetchUserInfo,
            user,
            anotherUser,
            loading,
            tokenExpired,
            setUser,
            setAnotherUser,
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
